/**
 * Vitgem — GA4 Ecommerce Event Tracking (consent-aware)
 * Events: view_item, add_to_cart
 * purchase and begin_checkout are sent from the Shopify custom pixel — see
 * analytics/shopify-custom-pixel-ga4.js. The theme layout does not load on
 * checkout or thank-you pages, and "Additional scripts" no longer exists.
 * Do not add a purchase event here: it would double-count.
 *
 * GDPR: every event is gated behind Shopify's Customer Privacy API. Nothing
 * fires until the visitor has granted analytics consent (default = deny).
 * Consent is collected by the installed consent app (Pandectes/Consentmo),
 * which also drives Google Consent Mode v2 (default denied in theme.liquid).
 */
(function () {
  'use strict';

  if (typeof gtag !== 'function') return;

  // ── consent gate ──────────────────────────────────────────────────────────
  // Returns true only when the shopper has actively allowed analytics.
  // Two accepted signals (default = DENY):
  //   1) Shopify Customer Privacy API — set by a consent app (Pandectes/Consentmo)
  //   2) our own Pop cookie banner's stored choice (vg_cookie_consent === 'accepted')
  // This keeps tracking consent-safe whether or not the dedicated app is installed.
  function consentAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        if (cp.analyticsProcessingAllowed()) return true;
      }
    } catch (e) {}
    try {
      if (localStorage.getItem('vg_cookie_consent') === 'accepted') return true;
    } catch (e) {}
    return false;
  }

  // ── view_item — fires on product pages (once, after consent) ──────────────
  var viewItemFired = false;
  function tryViewItem() {
    if (viewItemFired || !consentAllowed()) return;

    var productData = document.querySelector('[data-product-id]');
    if (!productData || window.location.pathname.indexOf('/products/') === -1) return;

    var meta = document.querySelector('meta[property="og:title"]');
    var priceMeta = document.querySelector('meta[property="og:price:amount"]');
    if (!meta || !priceMeta) return;

    viewItemFired = true;
    gtag('event', 'view_item', {
      currency: 'GBP',
      value: parseFloat(priceMeta.content),
      items: [{
        item_id: productData.dataset.productId,
        item_name: meta.content,
        currency: 'GBP',
        price: parseFloat(priceMeta.content)
      }]
    });
  }

  // try now, and again whenever consent is (re)collected
  tryViewItem();
  document.addEventListener('visitorConsentCollected', tryViewItem);

  // ── add_to_cart — fires when product form is submitted (if consent) ───────
  document.addEventListener('submit', function (e) {
    if (!consentAllowed()) return;

    var form = e.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    var productInfo = form.closest('[data-product-id]');
    if (!productInfo) return;

    var titleEl = document.querySelector('.product__title h1, .product__title h2');
    var priceEl = document.querySelector('.price--large .price-item--regular, .price--large .price-item--sale');
    var qtyInput = form.querySelector('input[name="quantity"]');

    var price = 0;
    if (priceEl) {
      price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    }

    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    gtag('event', 'add_to_cart', {
      currency: 'GBP',
      value: price * qty,
      items: [{
        item_id: productInfo.dataset.productId,
        item_name: titleEl ? titleEl.textContent.trim() : '',
        currency: 'GBP',
        price: price,
        quantity: qty
      }]
    });
  });
})();
